<template>
  <div id="pupils-languages">
    <h4 class="sub-title">Pupils and Languages</h4>
    <b-form-group>
      <div class="main-languages mt-4">
        <label for="main-languages">Main Languages (up to 3):</label>
        <br />
        <b-form-select name="main-languages" v-model="main_languages[0]">
          <option value disabled>Select a language</option>
          <option v-for="(lang, i) in languages" :key="i" :value="lang">
            {{ lang }}
          </option>
        </b-form-select>
        <br />
        <b-form-select name="main-languages" v-model="main_languages[1]">
          <option value disabled>Select a language</option>
          <option v-for="(lang, i) in languages" :key="i" :value="lang">
            {{ lang }}
          </option>
        </b-form-select>
        <br />
        <b-form-select name="main-languages" v-model="main_languages[2]">
          <option value disabled>Select a language</option>
          <option v-for="(lang, i) in languages" :key="i" :value="lang">
            {{ lang }}
          </option>
        </b-form-select>
      </div>
      <div class="language-instruction mt-4">
        <label for="language-instruction"
          >Language of Instruction (up to 3):</label
        >
        <br />
        <b-form-select
          name="main-languages"
          v-model="languages_of_instruction[0]"
        >
          <option value disabled>Select a language</option>
          <option v-for="(lang, i) in languages" :key="i" :value="lang">
            {{ lang }}
          </option>
        </b-form-select>
        <br />
        <b-form-select
          name="main-languages"
          v-model="languages_of_instruction[1]"
        >
          <option value disabled>Select a language</option>
          <option v-for="(lang, i) in languages" :key="i" :value="lang">
            {{ lang }}
          </option>
        </b-form-select>
        <br />
        <b-form-select
          name="main-languages"
          v-model="languages_of_instruction[2]"
        >
          <option value disabled>Select a language</option>
          <option v-for="(lang, i) in languages" :key="i" :value="lang">
            {{ lang }}
          </option>
        </b-form-select>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'PupilsLanguages',
  data() {
    return {
      languages: [
        'Chitumbuka',
        'Chichewa',
        'Chiyao',
        'Kavango',
        'Lozi',
        'Oshiwambo',
        'Otjiherero',
        'Nama/Damara/Khoekhoegowab',
        'San',
        'Afrikaans',
        'English',
        'German',
        'Portuguese',
        'Lozi',
        'Bemba',
        'Lunda',
        'Tonga',
        'Luvale',
        'Kaonde',
        'Nyanja',
      ],
    };
  },
  computed: {
    main_languages: {
      get() {
        return this.$store.state.schools.school.main_languages;
      },
      set(val) {
        this.$store.commit('schools/main_languages', val);
      },
    },
    languages_of_instruction: {
      get() {
        return this.$store.state.schools.school.languages_of_instruction;
      },
      set(val) {
        this.$store.commit('schools/language_of_instruction', val);
      },
    },
  },
};
</script>
